import React from 'react';
import Img from '../../Img';

class CancellableInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMenuShowed: false,
            displayMenuBelowAnchor: true,
        };
        this.handleAchorClick = this.handleAchorClick.bind(this);
        this.closePopUp = this.closePopUp.bind(this);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('touchend', this.handleClickOutside, false);
    }

    handleAchorClick(ev) {
        ev.stopPropagation();
        ev.preventDefault();

        // width reduced for Iphone 5 and small resolution devices
        let width = 300;
        if (window.innerWidth > 500) {
            width = 400;
        }

        // Values from left border
        let right = false;
        let transformValue = 'translateX(-50%)';
        let distanceFromBorder = ev.nativeEvent.clientX;

        if (ev.nativeEvent.clientX > window.innerWidth / 2) {
            // Values from right border
            right = true;
            distanceFromBorder = window.innerWidth - ev.nativeEvent.clientX;
            transformValue = 'translateX(50%)';
        }

        if (distanceFromBorder < width / 2) {
            if (right) {
                transformValue = `translateX(${distanceFromBorder}px)`;
            } else {
                transformValue = `translateX(${-distanceFromBorder}px)`;
            }
        }

        if (this.props.translateXValue) {
            transformValue = `translateX(${this.props.translateXValue})`;
        }

        let showBelow = true;
        if (ev.nativeEvent.clientY > (2 * window.innerHeight / 3)) {
            showBelow = false;
        }
        this.setState({
            isMenuShowed: true,
            displayMenuBelowAnchor: showBelow,
            hoverWidth: `${width}px`,
            rightAlign: right,
            transformValue,
        });
    }

    closePopUp() {
        this.setState({
            isMenuShowed: false,
        });
    }

    render() {
        /* const { rating } = this.props; */
        const PopUp = () => {
            return (
                <div
                    className={`rating-pop-up`}
                >
                    <div className="gradient-bar" />
                    <div className="pop-up-content">
                        <h5 className="text">{this.props.title}</h5>
                        <p className="text" dangerouslySetInnerHTML={{ __html: this.props.description }} />
                        <a
                            onClick={() => {
                                this.closePopUp();
                            }}
                            className={`btn btn-default btn-block text-uppercase`}
                        >
                            <span>{this.props.cancelText}</span>
                        </a>
                    </div>
                </div>
            );
        };

        return (
            <div className={`info-root ${this.props.rootClass ? this.props.rootClass : ''}`}>
                <Img
                    alt="tooltip"
                    src="/img/info-icon.svg"
                    className={`info-anchor ${this.props.anchorClass ? this.props.anchorClass : ''}`}
                    onClick={this.handleAchorClick}
                />
                {this.state.isMenuShowed && (
                    <div className="action-click-disabler" />
                )}
                <div
                    className={`info-container ${this.state.displayMenuBelowAnchor ? 'below-anchor' : 'above-anchor'} ${this.props.menuClass ? this.props.menuClass : ''}`}
                    style={this.state.rightAlign ? {
                        width: this.state.hoverWidth,
                        right: '15px',
                        transform: this.state.transformValue,
                    } : {
                        width: this.state.hoverWidth,
                        left: '30px',
                        transform: this.state.transformValue,
                    }}
                >
                    {this.state.isMenuShowed && (
                        <PopUp />
                    )}
                </div>
            </div>

        );
    }
}

export default CancellableInfo;
